import Component from "./ways-to-watch"

export default Component
